import { parse } from 'query-string';

export function searchStrFromRouterLocation(location) {
  let search
  if(location !=  undefined){
    search = parse(location.search).search;
  }
  return search || '';
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/utils/router.js